const swap = (object, a, b) => {
  const temp = object[a];
  object[a] = object[b];
  object[b] = temp;
};

export default swap;
